import React, { FunctionComponent } from 'react';
import Button from '$/components/ui/Button/index';
import { ReactComponent as CloseIcon } from '$/images/close.svg';
import tw from 'twin.macro';
import { css } from '@emotion/react';

interface BillingContactProps {
  isReadOnly: boolean;
  email: string;
  onRemove: (email: string) => void;
}

export const BillingContact: FunctionComponent<BillingContactProps> = ({
  email,
  onRemove,
  isReadOnly,
}) => {
  const onCloseClick = React.useCallback(() => {
    onRemove(email);
  }, [email, onRemove]);

  return (
    <div
      className='flex text-md justify-between mb-1e border-b w-full'
      css={css`
        margin: 0.67857143em 1em;
        width: calc(100% - 2 * 0.67857143em) !important;
      `}
    >
      <div
        css={css`
          max-width: 24rem;
          ${tw`w-10/12 overflow-hidden truncate`};
        `}
      >
        {email}
      </div>
      {!isReadOnly && (
        <Button onClick={onCloseClick}>
          <CloseIcon className='h-3 px-4' />
        </Button>
      )}
    </div>
  );
};

export default BillingContact;
